module.exports = __webpack_public_path__ + "static/media/image4.cbdf8166.jpg";